import { render, staticRenderFns } from "./PendingLetter.vue?vue&type=template&id=003ba836&scoped=true&"
import script from "./PendingLetter.vue?vue&type=script&lang=js&"
export * from "./PendingLetter.vue?vue&type=script&lang=js&"
import style0 from "./PendingLetter.vue?vue&type=style&index=0&id=003ba836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003ba836",
  null
  
)

export default component.exports